import * as React from 'react';

import { Widget } from '@typeform/embed-react';

type TypeformEmbedType = { id: string };
export function TypeformEmbed({ id }: TypeformEmbedType) {
  return <Widget id={id} style={{ height: '300px' }} />;
}
